import { IBranchYearRoundDTO, IPaginationDTO, IUserDTO } from '@/dtos';
import { generatePagination, get, post, remove } from '../apiWrapper';
import { IBranchYearJudgeDTO } from '@/dtos/branch.year.judge.dto';

export const getBranchYearJudgesAPI = async (
  branchId: string,
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: IBranchYearJudgeDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const judges = await get<{ data: IBranchYearJudgeDTO[]; count: number }>(
    `/admin/judges/${yearId}/branch/${branchId}${pageOptions}`,
  );
  return judges;
};

export const getJudgingRoundsAPI = async (
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: IBranchYearRoundDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const judges = await get<{ data: IBranchYearRoundDTO[]; count: number }>(
    `/admin/judges/${yearId}/rounds${pageOptions}`,
  );
  return judges;
};

export const addBranchYearRoundAPI = async (branchId: string, yearId: string): Promise<void> => {
  await post<{ data: IBranchYearRoundDTO[]; count: number }>(
    `/admin/judges/${yearId}/branch/${branchId}/add-round`,
  );
};

export const addBranchYearJudgesAPI = async (
  roundId: string,
  userIds: string[],
): Promise<boolean> => {
  await post(`/admin/judges/${roundId}/add-judges`, userIds);
  return true;
};

export const removeBranchYearJudgeAPI = async (
  roundId: string,
  judgeId: string,
): Promise<boolean> => {
  await remove(`/admin/judges/${roundId}/judge/${judgeId}`);
  return true;
};

export const updateBranchYearJudgeAPI = async (
  branchYearJudge: IBranchYearJudgeDTO,
): Promise<IBranchYearJudgeDTO> => {
  const result = await post<IBranchYearJudgeDTO>(
    `/admin/judges/judge/${branchYearJudge.id}`,
    branchYearJudge,
  );
  return result;
};
